import React from "react"
import style from "./ResponsiveTable.module.css"
const ResponsiveTable = ({ children }) => {
  return <table className={style.tableOuter}>{children}</table>
}

export default ResponsiveTable
